import { motion, AnimatePresence } from 'framer-motion';
import { Loader2, AlertTriangle } from 'lucide-react';
import { ResultCard } from '../result-card';
import { PlantDetails } from '../plant/PlantDetails';

export function IdentificationSection({
  isIdentifying,
  isUploading,
  error,
  result
}) {
  return (
    <div className="space-y-6">
      <AnimatePresence mode="wait">
        {(isIdentifying || isUploading) && (
          <motion.div
            key="loading"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="bg-white rounded-lg shadow-lg p-6"
          >
            <div className="flex flex-col items-center justify-center space-y-4">
              <Loader2 className="w-8 h-8 text-emerald-600 animate-spin" />
              <p className="text-gray-600 text-center">
                {isUploading ? 'Uploading image...' : 'Analyzing your plant...'}
                <br />
                <span className="text-sm text-gray-500">
                  This may take a few moments
                </span>
              </p>
            </div>
          </motion.div>
        )}

        {error && !isIdentifying && !isUploading && (
          <motion.div
            key="error"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="bg-red-50 rounded-lg p-6 flex items-start gap-3"
          >
            <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="font-medium text-red-800 mb-1">
                Identification Failed
              </h3>
              <p className="text-red-600 text-sm">{error}</p>
            </div>
          </motion.div>
        )}

        {result && !isIdentifying && !isUploading && !error && (
          <motion.div
            key="result"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="space-y-6"
          >
            <ResultCard plantName={result} />
            <PlantDetails plantInfo={result} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
